//提供全局的日志输出点，如果需要做一个日志收集，也可以从这里做
import env from './env'
const proto = {
  info: function(...arg) {
    if (!env.isPro()) {
      // eslint-disable-next-line no-console
      console.log(...arg)
    }
  },
  error: function(...arg) {
    if (!env.isPro()) {
      // eslint-disable-next-line no-console
      console.error(...arg)
    }
  },
  warn: function(...arg) {
    if (!env.isPro()) {
      // eslint-disable-next-line no-console
      console.warn(...arg)
    }
  }
}

const $log = function(...arg) {
  proto.info(...arg)
}

$log.info = proto.info
$log.warn = proto.warn
$log.error = proto.error

export default $log



// WEBPACK FOOTER //
// ./src/utils/log.js